import React from "react";
import { connect } from 'react-redux';
// import moment from 'moment';

import withStyles from "@material-ui/core/styles/withStyles";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import TrueMoneyPaymentReport from './TrueMoneyPaymentReport.jsx';
const style = {};

class TrueMoneyLinePaymentTransactionReportContainer extends React.Component {


  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: 'REPORT_REDUCER_INIT' })
  }


  render() {
    const { merchantSetting } = this.props;
    return (
      <Card>
        <CardBody>
          <TrueMoneyPaymentReport initialValues={{ startDate: null, endDate: null }} />
        </CardBody>
      </Card>
    )
  }
}

function mapStateToProps(state) {
  const { tableReset } = state.member;
  const { merchantSetting, user, superAdmin, permission } = state.authentication;
  return {
    tableReset, merchantSetting, user, superAdmin, permission
  };
}
const connectTrueMoneyLinePaymentTransactionReportContainer = connect(mapStateToProps)(TrueMoneyLinePaymentTransactionReportContainer);

export default withStyles(style)(connectTrueMoneyLinePaymentTransactionReportContainer);